
    import Vue from "vue";

    import { Component, Prop } from "vue-property-decorator";
    import { Menu, Input, Dropdown, Calendar } from "ant-design-vue";

    @Component({
        components: {
            "a-menu-item": Menu.Item,
            "a-menu": Menu,
            "a-input-search": Input.Search,
            "a-dropdown": Dropdown,
            "a-calendar": Calendar
        },

    })
    export default class EDateTimePicker extends Vue {
        @Prop() displayDate!: string;
        @Prop() size!: string;
        showDropDown: boolean = false;
        dDate = this.displayDate

        constructor() {
          super()
          if (this.displayDate) {
            this.dDate = this.displayDate
          } else {
            this.dDate = ''
          }
        }



        selectDate(date: any | string):void {
          this.showDropDown = false;
          this.dDate = new Date(date["_d"]).toLocaleDateString("ru-RU");
          this.$emit('selectDate', date);
        }

        //that.$emit("calendar_categoryAdd", category);

    }
